"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
class Habitos {
    constructor() {
        this.root = null;
        this.config = null;
        this.settingsOpener = null;
        this.storyController = null;
        this.storyLoader = null;
        this.storyOpenRequest = null;
        this.reviewComplete = false;
        this.answerQueue = Promise.resolve();
        this.progressRequest = null;
    }
    init() {
        this.root = document.querySelector("[data-habitos-app]");
        this.config = window.prepainHabitos || null;
        if (!this.root || !this.config)
            return;
        this.reviewComplete = this.root.dataset.reviewComplete === "true";
        this.root.addEventListener("click", (event) => this.onClick(event));
        this.root.addEventListener("submit", (event) => this.onSubmit(event));
        this.root.addEventListener("keydown", (event) => this.onKeyDown(event));
        this.initTutorialInvite();
    }
    initTutorialInvite() {
        const invite = this.root.querySelector("[data-habitos-tutorial-invite]");
        if (!invite)
            return;
        let dismissed = false;
        try {
            dismissed =
                window.localStorage.getItem("prepainHabitosTutorialInviteDismissed") !==
                    null;
        }
        catch (_a) {
            dismissed = false;
        }
        if (!dismissed)
            invite.hidden = false;
        const dismissButton = invite.querySelector("[data-habitos-tutorial-dismiss]");
        dismissButton === null || dismissButton === void 0 ? void 0 : dismissButton.addEventListener("click", () => {
            try {
                window.localStorage.setItem("prepainHabitosTutorialInviteDismissed", "1");
            }
            catch (_a) {
                // Safari private mode or storage disabled: dismiss just this view.
            }
            invite.classList.add("is-dismissing");
            window.setTimeout(() => {
                invite.hidden = true;
                invite.classList.remove("is-dismissing");
            }, 180);
        });
    }
    request(path, init = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield fetch(`${this.config.root}${path}`, Object.assign(Object.assign({}, init), { credentials: "same-origin", headers: Object.assign({ "Content-Type": "application/json", "X-WP-Nonce": this.config.nonce }, (init.headers || {})) }));
            const body = yield response.json();
            if (!response.ok) {
                const error = new Error(body.message || "No pudimos guardar el cambio.");
                error.code = body.code;
                throw error;
            }
            return body;
        });
    }
    onClick(event) {
        const target = event.target;
        const answer = target.closest("[data-habitos-answer]");
        if (answer) {
            // Keep responses in click order, including edits to different habits.
            this.answerQueue = this.answerQueue.then(() => this.saveAnswer(answer));
            return;
        }
        if (target.closest("[data-progress-refresh]")) {
            void this.refreshProgress();
            return;
        }
        const settingsOpener = target.closest("[data-habitos-open-settings]");
        if (settingsOpener) {
            this.toggleSettings(true, settingsOpener);
            return;
        }
        if (target.closest("[data-habitos-close-settings]")) {
            this.toggleSettings(false);
            return;
        }
        const storyOpener = target.closest("[data-habitos-open-story]");
        if (storyOpener && storyOpener.getAttribute("aria-disabled") !== "true") {
            void this.openStory(storyOpener);
            return;
        }
        const toggle = target.closest("[data-habitos-toggle]");
        if (toggle)
            void this.toggleHabit(toggle);
    }
    onKeyDown(event) {
        const settings = this.root.querySelector("[data-habitos-settings]");
        if (!settings || settings.hidden)
            return;
        if (event.key === "Escape") {
            event.preventDefault();
            this.toggleSettings(false);
            return;
        }
        if (event.key !== "Tab")
            return;
        const focusableSelector = [
            "a[href]",
            "button:not([disabled])",
            "input:not([disabled])",
            "select:not([disabled])",
            "textarea:not([disabled])",
            '[tabindex]:not([tabindex="-1"])',
        ].join(",");
        const controls = Array.from(settings.querySelectorAll(focusableSelector)).filter((control) => control.getClientRects().length > 0 &&
            control.getAttribute("aria-hidden") !== "true");
        if (!controls.length) {
            event.preventDefault();
            return;
        }
        const first = controls[0];
        const last = controls[controls.length - 1];
        const active = document.activeElement;
        if (event.shiftKey && (active === first || !settings.contains(active))) {
            event.preventDefault();
            last.focus();
        }
        else if (!event.shiftKey &&
            (active === last || !settings.contains(active))) {
            event.preventDefault();
            first.focus();
        }
    }
    onSubmit(event) {
        const form = event.target;
        if (form.matches("[data-habitos-onboarding]")) {
            event.preventDefault();
            void this.saveOnboarding(form);
        }
        if (form.matches("[data-habitos-custom-form]")) {
            event.preventDefault();
            void this.saveCustom(form);
        }
    }
    saveAnswer(button) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const row = button.closest("[data-habit-row]");
            if (!row || row.getAttribute("aria-busy") === "true")
                return;
            const state = this.root.querySelector("[data-habitos-save-state]");
            row.setAttribute("aria-busy", "true");
            if (state)
                state.textContent = "Guardando…";
            try {
                const dashboard = yield this.request(`reviews/today/answers/${button.dataset.habitId}`, {
                    method: "POST",
                    body: JSON.stringify({
                        answer: button.dataset.habitosAnswer === "yes",
                    }),
                });
                if (dashboard.day !== this.config.serverDay) {
                    if (state)
                        state.textContent = "El día cambió; preparamos tu nueva revisión.";
                    window.location.reload();
                    return;
                }
                this.render(dashboard);
                if (state)
                    state.textContent =
                        ((_a = dashboard.review) === null || _a === void 0 ? void 0 : _a.status) === "complete"
                            ? "Revisión completa. Tus respuestas están guardadas."
                            : "Respuesta guardada.";
            }
            catch (error) {
                const known = error;
                if (known.code === "habitos_day_changed")
                    window.location.reload();
                if (state)
                    state.textContent = known.message;
            }
            finally {
                row.removeAttribute("aria-busy");
            }
        });
    }
    render(dashboard) {
        var _a, _b;
        const review = dashboard.review;
        const active = dashboard.habits.length;
        const answered = (review === null || review === void 0 ? void 0 : review.answered_count) || 0;
        const complete = (review === null || review === void 0 ? void 0 : review.status) === "complete";
        const becameComplete = complete && !this.reviewComplete;
        this.reviewComplete = complete;
        const summary = this.root.querySelector("[data-habitos-complete-summary]");
        if (summary)
            summary.hidden = !complete;
        const yes = dashboard.habits.filter((habit) => habit.answer === true).length;
        this.text("[data-habitos-complete-count]", yes + " de " + active + " hábitos realizados");
        this.text("[data-habitos-review-label]", complete ? "Editar respuestas de hoy" : "Completar revisión de hoy");
        const editor = this.root.querySelector("[data-habitos-review]");
        if (becameComplete && editor) {
            const moveFocus = editor.contains(document.activeElement);
            editor.open = false;
            if (moveFocus) {
                (_a = this.root.querySelector("[data-habitos-complete-title]")) === null || _a === void 0 ? void 0 : _a.focus();
            }
        }
        if (becameComplete)
            void this.refreshProgress();
        this.config.shareOptions = dashboard.share_options;
        (_b = this.storyController) === null || _b === void 0 ? void 0 : _b.setOptions(dashboard.share_options);
        const celebration = this.root.querySelector("[data-habitos-story-celebration]");
        // Latch, don't flash: mirror the server-render condition (complete review
        // with story options) so re-answering a completed review keeps the card.
        if (celebration)
            celebration.hidden = !(complete && dashboard.share_options.length > 0);
        const permanentEntry = this.root.querySelector('[data-habitos-open-story="permanent"]');
        const storyAvailable = dashboard.share_options.length > 0;
        if (permanentEntry) {
            if (storyAvailable) {
                permanentEntry.removeAttribute("aria-disabled");
                permanentEntry.removeAttribute("aria-describedby");
            }
            else {
                permanentEntry.setAttribute("aria-disabled", "true");
                permanentEntry.setAttribute("aria-describedby", "habitos-story-unavailable");
            }
        }
        const guidance = this.root.querySelector("#habitos-story-unavailable");
        if (guidance)
            guidance.hidden = storyAvailable;
        const score = complete ? (review === null || review === void 0 ? void 0 : review.score_pct) || 0 : 0;
        const ring = this.root.querySelector(".habitos-ring");
        if (ring) {
            ring.style.setProperty("--habitos-score", String(score));
            ring.setAttribute("aria-label", complete
                ? `${score} por ciento de balance`
                : `Revisión pendiente, ${answered} de ${active} revisados`);
        }
        this.text("[data-habitos-score]", complete ? `${score}%` : "—");
        this.text("[data-habitos-ring-label]", complete ? "balance de hoy" : `${answered} de ${active} revisados`);
        this.text("[data-habitos-balance-title]", complete ? "Así se sintió tu balance" : "Tu reflexión está en marcha");
        this.text("[data-habitos-count]", `${answered} de ${active}`);
        this.text("[data-habitos-progress-label]", complete ? "Completa" : "Pendiente");
        this.text("[data-habitos-streak]", String(dashboard.streak));
        this.text("[data-habitos-streak-unit]", dashboard.streak === 1 ? "día de revisión" : "días de revisión");
        const progress = this.root.querySelector("[data-habitos-progress]");
        if (progress)
            progress.style.width = `${active ? (answered / active) * 100 : 0}%`;
        dashboard.habits.forEach((habit) => {
            const row = this.root.querySelector(`[data-habit-row="${habit.id}"]`);
            if (!row)
                return;
            row
                .querySelectorAll("[data-habitos-answer]")
                .forEach((answer) => {
                const selected = (answer.dataset.habitosAnswer === "yes") === habit.answer &&
                    habit.answer !== null;
                answer.classList.toggle("is-selected", selected);
                answer.setAttribute("aria-pressed", selected ? "true" : "false");
            });
        });
        dashboard.categories.forEach((category) => {
            const card = this.root.querySelector(`[data-category="${CSS.escape(category.name)}"]`);
            if (!card)
                return;
            const done = category.active_count > 0 &&
                category.answered_count === category.active_count;
            const scoreNode = card.querySelector("[data-category-score]");
            const statusNode = card.querySelector("[data-category-status]");
            if (scoreNode)
                scoreNode.textContent = category.active_count
                    ? `${category.yes_count} de ${category.active_count} Sí`
                    : "—";
            if (statusNode)
                statusNode.textContent = done
                    ? "Revisado"
                    : category.active_count
                        ? "Pendiente"
                        : "Sin hábitos";
        });
        const today = this.root.querySelector(`[data-history-day="${dashboard.day}"]`);
        if (today) {
            const level = complete
                ? score === 0
                    ? 1
                    : Math.min(4, Math.ceil(score / 25))
                : "unreviewed";
            today.dataset.level = String(level);
            today.setAttribute("aria-label", `Hoy: ${complete ? `${score} por ciento` : "sin revisión"}`);
        }
    }
    refreshProgress() {
        var _a;
        if (!((_a = this.config) === null || _a === void 0 ? void 0 : _a.progressUrl))
            return Promise.resolve();
        if (this.progressRequest)
            return this.progressRequest;
        this.progressRequest = this.performProgressRefresh().finally(() => {
            this.progressRequest = null;
        });
        return this.progressRequest;
    }
    performProgressRefresh() {
        return __awaiter(this, void 0, void 0, function* () {
            const retry = this.root.querySelector("[data-progress-refresh]");
            if (retry)
                retry.disabled = true;
            this.text("[data-progress-status]", "Actualizando tu constancia…");
            try {
                const response = yield fetch(this.config.progressUrl, {
                    credentials: "same-origin",
                    cache: "no-store",
                    headers: { "X-WP-Nonce": this.config.nonce },
                });
                if (!response.ok)
                    throw new Error("progress_refresh_failed");
                const fragments = yield response.json();
                for (const part of ["summary", "activity", "achievements"]) {
                    if (typeof fragments[part] !== "string") {
                        throw new Error("progress_refresh_failed");
                    }
                }
                for (const part of ["summary", "activity", "achievements"]) {
                    const node = this.root.querySelector("[data-progress-" + part + "]");
                    // Same-origin, authenticated fragments rendered by theme partials.
                    if (node)
                        node.innerHTML = fragments[part];
                }
                this.text("[data-progress-status]", "Tu constancia está actualizada.");
                if (retry) {
                    if (document.activeElement === retry) {
                        const status = this.root.querySelector("[data-progress-status]");
                        status === null || status === void 0 ? void 0 : status.setAttribute("tabindex", "-1");
                        status === null || status === void 0 ? void 0 : status.focus();
                    }
                    retry.hidden = true;
                }
            }
            catch (_a) {
                this.text("[data-progress-status]", "Tus hábitos están guardados. No pudimos actualizar la racha.");
                if (retry)
                    retry.hidden = false;
            }
            finally {
                if (retry)
                    retry.disabled = false;
            }
        });
    }
    openStory(opener) {
        if (this.storyOpenRequest)
            return this.storyOpenRequest;
        const request = this.performOpenStory(opener).finally(() => {
            if (this.storyOpenRequest === request)
                this.storyOpenRequest = null;
        });
        this.storyOpenRequest = request;
        return request;
    }
    performOpenStory(opener) {
        return __awaiter(this, void 0, void 0, function* () {
            const storyRoot = this.root.querySelector("[data-habitos-story]");
            if (!storyRoot || !this.config.shareOptions.length)
                return;
            try {
                yield this.loadStoryBundle();
                if (!this.storyController) {
                    this.storyController = window.prepainHabitosStory.create(storyRoot, {
                        medalUrls: this.config.medalUrls,
                        shareOptions: this.config.shareOptions,
                    });
                }
                this.storyController.open(opener);
            }
            catch (error) {
                const state = this.root.querySelector("[data-habitos-save-state]");
                if (state)
                    state.textContent = error.message;
            }
        });
    }
    loadStoryBundle() {
        if (window.prepainHabitosStory)
            return Promise.resolve();
        if (this.storyLoader)
            return this.storyLoader;
        this.storyLoader = new Promise((resolve, reject) => {
            const script = document.createElement("script");
            script.src = this.config.storyScriptUrl;
            script.async = true;
            script.onload = () => {
                if (window.prepainHabitosStory) {
                    resolve();
                    return;
                }
                reject(new Error("No pudimos abrir el creador. Recarga la página e intenta de nuevo."));
            };
            script.onerror = () => reject(new Error("No pudimos abrir el creador. Recarga la página e intenta de nuevo."));
            document.head.appendChild(script);
        });
        return this.storyLoader;
    }
    saveOnboarding(form) {
        return __awaiter(this, void 0, void 0, function* () {
            const keys = Array.from(form.querySelectorAll('input[name="catalog_key[]"]:checked')).map((input) => input.value);
            const error = form.querySelector("[data-habitos-form-error]");
            if (keys.length < 3 || keys.length > 7) {
                if (error)
                    error.textContent = "Elige entre 3 y 7 hábitos.";
                return;
            }
            try {
                for (const catalog_key of keys) {
                    yield this.request("habits", {
                        method: "POST",
                        body: JSON.stringify({ catalog_key }),
                    });
                }
                window.location.reload();
            }
            catch (problem) {
                if (error)
                    error.textContent = problem.message;
            }
        });
    }
    toggleHabit(button) {
        return __awaiter(this, void 0, void 0, function* () {
            const error = this.root.querySelector("[data-habitos-settings-error]");
            try {
                yield this.request(`habits/${button.dataset.habitosToggle}`, {
                    method: "PATCH",
                    body: JSON.stringify({ status: button.dataset.status }),
                });
                window.location.reload();
            }
            catch (problem) {
                if (error)
                    error.textContent = problem.message;
            }
        });
    }
    saveCustom(form) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = new FormData(form);
            const error = this.root.querySelector("[data-habitos-settings-error]");
            try {
                yield this.request("habits", {
                    method: "POST",
                    body: JSON.stringify({
                        label: data.get("label"),
                        category: data.get("category"),
                        icon: "sparkle",
                    }),
                });
                window.location.reload();
            }
            catch (problem) {
                if (error)
                    error.textContent = problem.message;
            }
        });
    }
    toggleSettings(open, opener = null) {
        var _a, _b;
        const settings = this.root.querySelector("[data-habitos-settings]");
        if (!settings)
            return;
        settings.hidden = !open;
        if (open) {
            this.settingsOpener = opener;
            (_a = settings
                .querySelector("[data-habitos-dialog-close]")) === null || _a === void 0 ? void 0 : _a.focus();
            return;
        }
        (_b = this.settingsOpener) === null || _b === void 0 ? void 0 : _b.focus();
        this.settingsOpener = null;
    }
    text(selector, value) {
        const node = this.root.querySelector(selector);
        if (node)
            node.textContent = value;
    }
}
exports.default = Habitos;
